import classnames from 'classnames/bind'
import Recruiter from 'entities/recruiter'
import PropTypes from 'prop-types'
import React, { useState } from 'react'
import styles from './introducer_label.module.scss'
import IntroducerLabelCard from './introducer_label_card'

const cx = classnames.bind(styles)

const IntroducerLabel = ({ device_name: deviceName, introducer, selectable, onClickDeselect }) => {
  if (!introducer) {
    return null
  }

  const [showCard, setShowState] = useState(false)
  const eventProps = (() => {
    // 名前にフォーカスした際に、カードを出すイベントのバインドを行う
    if (deviceName === 'iphone' || deviceName === 'android') {
      // スマホ用のイベントをバインドする
      return {
        onTouchEnd: () => setShowState(!showCard),
        onClick: () => setShowState(!showCard)
      }
    }

    // PC用のイベントをバインドする
    return {
      onMouseEnter: () => setShowState(true),
      onMouseLeave: () => setShowState(false)
    }
  })()

  return (
    <div className={styles.container}>
      <div className={cx(styles.label, { labelDeselectable: !selectable })} {...eventProps}>
        <span className={styles.introducerName}>{introducer ? introducer.name : null}</span>
        {selectable ? (
          <button type="button" className={cx(styles.buttonCancel)} onClick={() => onClickDeselect()}>
            <i className="ic-close" />
          </button>
        ) : null}
      </div>
      <IntroducerLabelCard introducer={introducer} show={showCard} />
    </div>
  )
}

IntroducerLabel.propTypes = {
  introducer: PropTypes.instanceOf(Recruiter),
  selectable: PropTypes.bool.isRequired,
  device_name: PropTypes.string.isRequired,
  onClickDeselect: PropTypes.func.isRequired
}

IntroducerLabel.defaultProps = {
  introducer: null
}

export default IntroducerLabel
